import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class newsletterSegmentList_template extends vnTemplate {
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword
            },
        };
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            segments: ko.observableArray([]),
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("id_DESC"),
            permissions: ko.observableArray(this.initPermissions(['newsletter_segments'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewSegment: (data, event) => {
                self.viewSegment(data.id, event);
            },
            onClickAdd: () => {
                self.onClickAdd();
            }
        };
    }

    protected getTemplateHtml(): string {
        return `
            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="event: {click: onClickAdd}, visible: permissions()['newsletter_segments'] && permissions()['newsletter_segments'].write" class="btn secondary icon i-add" type="button">Create Segment</button>
                </div>
                <div class="w-center">
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>
                <div class="w-right">
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='isActive_DESC', 'list-sort-asc': orderByAndDirection()=='isActive_ASC' }">Active</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: segments">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewSegment }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewSegment }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: title"></span></a></td>
                            <td data-bind="event: { click: $parent.viewSegment }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: isActive ? 'Yes' : 'No'"></span></a></td>
                            <td data-bind="event: { click: $parent.viewSegment }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewSegment }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateUpdated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "newsletterSegmentList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    public setResultInfo(nbResults, nbPages, execTime): void {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSegments(segments, brandId): void {
        segments.forEach((segment) => segment['emakiView'] = '/brand/' + brandId + '/newsletter/segments/view/' + segment.id + '/');
        this.getTemplateViewModel().segments(segments);
    }

    public setPermissions(permissions): void {
        this.getTemplateViewModel().permissions(permissions);
    }

    protected viewSegment(id, event): any {
        this.caller.view(id);
    }

    protected onClickAdd(): any {
        this.caller.add();
    }

    protected onClickReorder(value, data, event): any {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() == "DESC" ? "ASC" : "DESC");
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.segmentsListReorder();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterSegmentList_template.ts